/**
 * `#rgb` or `#rrggbb` at an opacity.
 *
 * The tag palette and the swipe band are both hex, and both need to be drawn
 * see-through in places — over a ticket's paper, and as a gradient that has to
 * start at nothing.
 */
export function withAlpha(hex: string, alpha: number): string {
  const digits = hex.slice(1);
  const n = parseInt(digits.length === 3 ? [...digits].map((d) => d + d).join('') : digits, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}
